import React from 'react';
import { ShuffleTraitRarities, shuffleTraitRarityPercentages } from '../config/shuffleTraits';
import Tag from './Tag';

const TraitShuffleRarityKey = () => {
  return (
    <div className='mt-4 p-4 rounded-lg bg-gray-900/50 border border-gray-800'>
      <h3 className='text-white font-medium mb-3'>Trait Shuffle Odds</h3>
      <div className='flex flex-wrap gap-2'>
        <div className='flex items-center gap-2'>
          <Tag theme='gray'>
            {ShuffleTraitRarities.Common} - {shuffleTraitRarityPercentages[ShuffleTraitRarities.Common]}%
          </Tag>
        </div>

        <div className='flex items-center gap-2'>
          <Tag theme='uncommon'>
            {ShuffleTraitRarities.Uncommon} - {shuffleTraitRarityPercentages[ShuffleTraitRarities.Uncommon]}%
          </Tag>
        </div>

        <div className='flex items-center gap-2'>
          <Tag theme='rare'>
            🌟 {ShuffleTraitRarities.Rare} - {shuffleTraitRarityPercentages[ShuffleTraitRarities.Rare]}%
          </Tag>
        </div>

        <div className='flex items-center gap-2'>
          <Tag theme='ultra-rare'>
            💎 {ShuffleTraitRarities.UltraRare} - {shuffleTraitRarityPercentages[ShuffleTraitRarities.UltraRare]}%
          </Tag>
        </div>
      </div>
    </div>
  );
};

export default TraitShuffleRarityKey;
